export default __webpack_public_path__ + "static/media/save.43ca4275.svg";